document.addEventListener('DOMContentLoaded', function(){

  // Fix rebuy height if opened in a non-active tab
  document.addEventListener('rebuy.ready', function(event){
    var widgetId = event.detail.widget.id;
    
    // Set height of carousel to height of product block but only if the carousel did not set its own height
    var style = document.createElement('style');
    style.type = 'text/css';
    style.innerHTML = '#rebuy-widget-' + widgetId + ' .flickity-viewport[style*="height: auto;"] { height: ' + $('#rebuy-widget-' + widgetId + ' .rebuy-product-block').outerHeight() + 'px !important; }';
    document.getElementsByTagName('head')[0].appendChild(style);
  });

});